import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'

import CustomButton from '@/components/custom-button'
import { useApplianceControls, useRefactoredApplianceControlTest } from '@/hooks/use-appliance-control'

export default function TuyaTest({ applianceId, successCallback }) {

    const { status, data, error } = useApplianceControls(applianceId)

    if (status === 'pending') {
        return <CircularProgress />
    }

    if (error) {
        return (
            <Alert severity="error">
                Nepovedlo se spojit se zásuvkou.
                Zkuste to zopakovat za chvíli, případně prosím opakujte nastavení zásuvky.
            </Alert>
        )
    }

    return (
        <>
            {data && data.length > 0 && (
                <TuyaTestButton
                    applianceControlId={data[0].id}
                    successCallback={successCallback}
                />
            )}
        </>
    )
}

function TuyaTestButton({
    applianceControlId,
    successCallback,
}: {
    applianceControlId: string | number | undefined
    successCallback: (arg1: boolean) => void
}) {
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState<boolean>(false)

    useEffect(() => {
        setSuccess(false)
        successCallback(false)
    }, [applianceControlId])

    const handleSetSuccess = (bool: boolean) => {
        setSuccess(bool)
        if (bool) successCallback(true)
    }

    const mutation = useRefactoredApplianceControlTest(
        applianceControlId,
        setError,
        handleSetSuccess,
    )

    return (
        <Box display="flex" flexDirection="column" mt={2}>
            <Box display="flex" justifyContent="center">
                <CustomButton
                    variant="outlined"
                    color="primary"
                    text="Vyzkoušet spojení se zásuvkou"
                    onClick={() => {
                        mutation.mutate()
                    }}
                    loading={mutation.isPending}
                />
            </Box>
            {success &&
                <Alert severity="success" sx={{ mt: 2 }}>
                    Test proběhl úpěšně.
                </Alert>
            }
            {error &&
                <Alert severity="error" sx={{ mt: 2 }}>
                    Nepovedlo se spojit se zásuvkou.
                    Zkuste to zopakovat za chvíli, případně prosím opakujte nastavení zásuvky.
                </Alert>
            }
        </Box>
    )
}
